import Vue from 'vue';

const isoCountries = require("i18n-iso-countries");

isoCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));
isoCountries.registerLocale(require("i18n-iso-countries/langs/es.json"));

const defaultLocale = 'es';

function createI18nCountry(locale) {

    const getCountryNameForRegion = (region) => {
        const country = isoCountries.getName(region, locale);
        if(country) {
            return country;
        }

        return isoCountries.getName(region, defaultLocale);
    }

    const countriesObject = isoCountries.getNames(locale);

    const countries = Object.keys(countriesObject)
        .map(key => { return { code: key, name: countriesObject[key] } })
        .sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            }
      
            if (a.name < b.name) {
              return -1;
            }
      
            return 0;
        });

    Vue.prototype.$i18nCountries = {
        getCountryNameForRegion,
        countries
    };
}

export default (locale = defaultLocale) => createI18nCountry(locale);